/**
 * Book Card Component
 * Displays a book with cover image, title, and description
 */

import type { BookData } from '@data/books'

interface BookCardProps {
  book: BookData
}

export default function BookCard({ book }: BookCardProps) {
  return (
    <div className="card book-card">
      <a
        href={book.url}
        target="_blank"
        rel="noopener noreferrer"
        className="book-card__link"
      >
        <img src={book.image} alt={book.title} className="book-card__cover" />
        <h3 className="book-card__title">{book.title}</h3>
      </a>
      <p
        className="book-card__description"
        dangerouslySetInnerHTML={{ __html: book.description }}
      />
    </div>
  )
}
